import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex flex-col gap-1"
};
const _hoisted_2 = ["disabled"];
const _hoisted_3 = {
    key: 0,
    class: "animate animate-bouncing animate-iteration-count-infinite"
};
const _hoisted_4 = { key: 1 };
const _hoisted_5 = {
    key: 0,
    "data-testid": "create-pdf-error",
    class: "max-w-xs text-xs text-red-600"
};
import { computed, watch } from "vue";
import { IconFileTypePdf } from "@tabler/icons-vue";
import { useToast } from "vue-toastification";
import { canDownloadItineraryPdf } from "@/domains/itinerary/services";
import { useItineraryI18n, useItineraryPdfDownload } from "@/domains/itinerary/composables";
export default /*@__PURE__*/ _defineComponent({
    __name: 'CreatePDFButton',
    props: {
        itinerary: {}
    },
    setup(__props) {
        const props = __props;
        const toast = useToast();
        const { t } = useItineraryI18n();
        const { isDownloading, statusMessage, errorMessage, downloadPdf } = useItineraryPdfDownload();
        const canDownload = computed(() => canDownloadItineraryPdf(props.itinerary));
        watch(errorMessage, (message) => {
            if (message)
                toast.error(message);
        });
        async function downloadPDF() {
            if (isDownloading.value || !canDownload.value)
                return;
            const itineraryId = Number(props.itinerary.id);
            if (!Number.isFinite(itineraryId)) {
                errorMessage.value = t("itinerary.pdf.missing_id", "El itinerario no tiene un identificador válido.");
                return;
            }
            await downloadPdf(itineraryId);
            if (!errorMessage.value) {
                toast.success(t("itinerary.pdf.success", "PDF descargado correctamente"));
            }
        }
        return (_ctx, _cache) => {
            return (canDownload.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("button", {
                        type: "button",
                        "data-testid": "create-pdf-button",
                        class: "flex gap-1 px-4 py-1 text-sm text-white transition-colors bg-eblack-400 rounded-xl item-center disabled:cursor-not-allowed disabled:opacity-60",
                        disabled: _unref(isDownloading),
                        onClick: downloadPDF
                    }, [
                        _createVNode(_unref(IconFileTypePdf), {
                            class: "w-5 h-5",
                            stroke: "{2}"
                        }),
                        (_unref(isDownloading))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_unref(statusMessage) ?? _unref(t)("itinerary.pdf.downloading", "Descargando...")), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)("itinerary.pdf.download", "Descargar itinerario")), 1))
                    ], 8, _hoisted_2),
                    (_unref(errorMessage))
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(errorMessage)), 1))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true);
        };
    }
});
